import { clientInstance } from '../utils/http-client'
import { PaginatedResponse } from '../models/paginated-response'
import { baseAPICall } from './baseAPICall'
import { GrantConnection } from 'models/grant'

export async function getGrantsList(params = {}, signal?: AbortSignal) {
  return baseAPICall<PaginatedResponse<GrantConnection>>(() =>
    clientInstance.get(`/nylas/grants/`, {
      params,
      signal,
    })
  )
}

export async function deleteGrant(grantId: string) {
  return baseAPICall(() => clientInstance.delete(`/nylas/grants/${grantId}/`))
}

export interface UpdateGrantPreferencesData {
  is_email_shared?: boolean
  is_calendar_shared?: boolean
  selected_calendar_id?: number | null
  remove_feature?: 'email' | 'calendar'
}

export async function updateGrantPreferences(
  grantId: string,
  data: UpdateGrantPreferencesData
) {
  return baseAPICall<GrantConnection>(() =>
    clientInstance.patch(`/nylas/grants/${grantId}/`, data)
  )
}
